// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subtitlesCommentPopup{
    display: flex;
    flex-direction: column;
    gap: 15px;
    background: #FFFFFF;
    box-shadow: 0px 4px 58px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    padding: 18px 20px;
}

.subtitlesCommentPopup_head{
    display: flex;
    justify-content: space-between;
}

.subtitlesCommentPopup_title{
    font-weight: 700;
    font-size: 14px;
    line-height: 23px;

    color: #121212;
}

.subtitlesCommentPopup_close{
    width: 20px;
    height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 0;
}

.subtitlesCommentPopup_main{

}

.subtitlesCommentPopup_input{
    display: block;
    width: 100%;
    height: 134px;

    background: #FFFFFF;
    border: 1px solid #CECECE;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);
    border-radius: 24px;
    resize: none;

    font-style: inherit;
    font-family: inherit;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    padding: 12px;
}

.subtitlesCommentPopup_buttons{
    display: flex;
}

.subtitlesCommentPopup_buttonDone{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    height: 40px;

    background: #FFA825;
    border-radius: 24px;
    color: #FFFFFF;

    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
}


`, "",{"version":3,"sources":["webpack://./src/components/subtitles/SubtitlesCommentPopup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAA+C;IAC/C,4BAA4B;IAC5B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;;IAEb,mBAAmB;IACnB,yBAAyB;IACzB,iDAAiD;IACjD,mBAAmB;IACnB,YAAY;;IAEZ,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;;IAEZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;;IAEd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".subtitlesCommentPopup{\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    background: #FFFFFF;\n    box-shadow: 0px 4px 58px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    padding: 18px 20px;\n}\n\n.subtitlesCommentPopup_head{\n    display: flex;\n    justify-content: space-between;\n}\n\n.subtitlesCommentPopup_title{\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 23px;\n\n    color: #121212;\n}\n\n.subtitlesCommentPopup_close{\n    width: 20px;\n    height: 20px;\n    background-image: url(\"../../assets/close.svg\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    font-size: 0;\n}\n\n.subtitlesCommentPopup_main{\n\n}\n\n.subtitlesCommentPopup_input{\n    display: block;\n    width: 100%;\n    height: 134px;\n\n    background: #FFFFFF;\n    border: 1px solid #CECECE;\n    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.1);\n    border-radius: 24px;\n    resize: none;\n\n    font-style: inherit;\n    font-family: inherit;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 16px;\n    padding: 12px;\n}\n\n.subtitlesCommentPopup_buttons{\n    display: flex;\n}\n\n.subtitlesCommentPopup_buttonDone{\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 40px;\n    height: 40px;\n\n    background: #FFA825;\n    border-radius: 24px;\n    color: #FFFFFF;\n\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
